import {TranslateService} from '@ngx-translate/core';

import {DashboardChartUtils} from './dashboard-chart.utils';

import {ChartUtils} from '../../+postpayroll/check/key-metrics/charts/chart.utils';
import {BasicPie} from '../../+postpayroll/check/key-metrics/charts/pie/basic-pie';
import {Chart} from '../../+postpayroll/check/key-metrics/key-metrics.interfaces';
import {LocalizationService} from '../../shared/localization/localization.service';
import {ChartBoxElement, DashboardBox, ResponseChartBox} from '../dashboard.interfaces';

export class ContractTypesChart extends BasicPie {
  constructor(chartBox: ResponseChartBox,
              translate: TranslateService,
              localization: LocalizationService) {
    const params = chartBox.params[Object.keys(chartBox.params)[0]];
    const chart: Chart = ChartUtils.getEmptyChart();

    params.forEach((element: ChartBoxElement) => {
      chart.data.push({
        category: element.name,
        name: element.name,
        value: element.value,
        metadata: element.link
      });
    });
    chart.type = chartBox.cardType;

    super(chart, translate, localization);

    this.legend = {
      orient: 'vertical',
      top: 0, // or 'top'
      left: 0,
      itemGap: 2
    };
    this.series[0].radius = '60%';
    this.series[0].center = ['50%', '70%'];
    this.series[0].itemStyle.normal.label = {
      show: false
    };
    this.animation = true;
    this.tooltip.position = DashboardChartUtils.getTooltipPositionFunc(<DashboardBox>chartBox);

    this.color = DashboardChartUtils.standardColors();
  }
}
